import { Modal } from "antd";
import { CloseIcon } from "assets";
import React from "react";

const ModalResults = ({
  isShowModal,
  handleCancel,
  children,
  title,
  width = 900,
  minHeight = 730 ,
  heightContent = 640
}) => {
  return (
    <Modal
      title={title}
      style={{ margin: 40, minHeight: minHeight ? minHeight : "730px" }}
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={width}
      className="modal"
      closeIcon={<CloseIcon />}
      footer=""
    >
      <div
        className="table"
        style={{ minHeight: heightContent ? heightContent : "640px", position: "relative" }}
      >
        {children}
      </div>
    </Modal>
  );
};

export default ModalResults;
